module.exports = __webpack_public_path__ + "static/media/climate_workplace_1_powerProductionSites.349e1d6c.jpg";